import { render, staticRenderFns } from "./BundleCandidates.vue?vue&type=template&id=f00a88bc&scoped=true"
import script from "./BundleCandidates.vue?vue&type=script&lang=js"
export * from "./BundleCandidates.vue?vue&type=script&lang=js"
import style0 from "./BundleCandidates.vue?vue&type=style&index=0&id=f00a88bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00a88bc",
  null
  
)

export default component.exports